import React from "react";
// Register Rules Screen

// Default
import { useState } from "react";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";

// Custom
import Layout from "../../layout";
import ContainedButton from "../../forms/button/ContainedButton";
import CustomSearchBox from "../search/SearchBox";
import CustomInput from "../../forms/input/Input";
import CustomOutlinedSelect from "../../forms/select/OutlinedCustomSelect";
import CardContent from "@mui/material/CardContent";
import CustomSearch from "../search/Search";
import DatePickerInput from "../../forms/input/DatePickerInput";

// Types
interface RegisterTypeForOperand {
  value1: string;
  value2: string;
  value3: string;
  value4: string;
}

interface OptionType {
  label: string;
  value: string;
}

const RegisterRules: React.FC = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [registerRuleType, setRegisterRuleType] = useState("");
  const [registerTypeForOperand, setRegisterTypeForOperand] =
    useState<RegisterTypeForOperand>({
      value1: "",
      value2: "",
      value3: "",
      value4: "",
    });

  const handleChange = (value: string, type: string) => {
    setRegisterTypeForOperand((prev) => ({ ...prev, [type]: value }));
  };

  return (
    <Layout>
      <Card className="register_rules_title_card">
        <Typography variant="h5">Register Rules</Typography>
      </Card>

      <Card
        className="register_rules_search_card"
        sx={{
          overflow: "visible",
          position: "relative",
        }}
      >
        <Typography variant="body1" fontWeight={600}>
          Register Rules ID
        </Typography>

        <Stack direction={"row"} gap={"10px"} alignItems={"center"}>
          <CustomSearchBox
            placeholder={"Enter 10 Digit"}
            width={"500px"}
            height={"40px"}
            handleSearchToggle={() => setSearchOpen(!searchOpen)}
            searchOpen={searchOpen}
            dialogBody={
              <Stack direction={"column"} gap={"20px"}>
                <CustomInput label={"First Name"} />
                <CustomInput label={"Register Rule Types"} />
                <ContainedButton
                  label={"Submit"}
                  sx={{
                    width: "100%",
                    fontWeight: 600,
                    color: "#ffffff",
                  }}
                />
              </Stack>
            }
          />

          <ContainedButton
            label={"Save"}
            sx={{
              width: "fit-content",
              fontWeight: 600,
              height: "35px",
              color: "#ffffff",
            }}
          />
        </Stack>
      </Card>

      <Card sx={{ mt: "20px" }}>
        <CardHeader
          title={
            <Typography variant="body1" fontWeight={"500"}>
              Register Rules
            </Typography>
          }
        />
        <Divider />

        <CardContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 4, lg: 4 }}>
              <CustomInput
                label={"Register Rule Code"}
                placeholder={"TOT_ACT_KWH_IMP"}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 4, lg: 4 }}>
              <CustomOutlinedSelect
                label={"Register Rule Types"}
                options={[
                  { label: "Fetch Consumption", value: "fetch_consumption" },
                  {
                    label: "Compute Consumption",
                    value: "compute_consumption",
                  },
                  { label: "Placeholder", value: "placeholder" },
                ]}
                placeholder={"Select Register Rule Type"}
                onChange={(e) => setRegisterRuleType(e.value as string)}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 4, lg: 4 }}>
              <DatePickerInput
                label={"Rule Activation Date Time"}
                placeholder={"dd/mm/yyyy hh:mm"}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12, lg: 12 }} mt={"10px"}>
              <Stack direction={"column"} gap={"15px"}>
                <Typography variant="body1">Register Type ID:</Typography>
                <Stack direction={"row"} gap={3} alignItems={"center"}>
                  <CustomSearch
                    sx={{ width: "700px", height: "40px" }}
                    placeholder={"Enter Register Type Id"}
                    isIcon={false}
                  />
                  <ContainedButton
                    label={"Register Type ID"}
                    sx={{
                      width: "fit-content",
                      fontWeight: 600,
                      color: "#ffffff",
                    }}
                  />
                </Stack>
              </Stack>
            </Grid>

            {registerRuleType === "compute_consumption" && (
              <>
                <Grid size={{ xs: 12, md: 12, lg: 12 }} mt={"10px"}>
                  <Stack direction={"column"} gap={"15px"}>
                    <Typography variant="body1">
                      Register Type For Operand 1:
                    </Typography>
                    <Stack direction={"row"} gap={3} alignItems={"center"}>
                      <Stack
                        direction={"row"}
                        gap={"20px"}
                        alignItems={"center"}
                      >
                        <CustomInput
                          type="number"
                          onChange={(event) =>
                            handleChange(event.target.value, "value1")
                          }
                          sx={{ width: "480px" }}
                        />
                        <CustomInput
                          type="number"
                          onChange={(event) =>
                            handleChange(event.target.value, "value2")
                          }
                          sx={{ width: "200px" }}
                        />
                      </Stack>
                      <ContainedButton
                        label={"Register Type ID"}
                        sx={{
                          width: "fit-content",
                          fontWeight: 600,
                          color: "#ffffff",
                        }}
                      />
                    </Stack>
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 12, lg: 12 }} mt={"10px"}>
                  <Stack direction={"column"} gap={"15px"}>
                    <Typography variant="body1">
                      Register Type For Operand 2:
                    </Typography>
                    <Stack direction={"row"} gap={3} alignItems={"center"}>
                      <Stack
                        direction={"row"}
                        gap={"20px"}
                        alignItems={"center"}
                      >
                        <CustomInput
                          type="number"
                          onChange={(event) =>
                            handleChange(event.target.value, "value3")
                          }
                          sx={{ width: "480px" }}
                        />
                        <CustomInput
                          type="number"
                          onChange={(event) =>
                            handleChange(event.target.value, "value4")
                          }
                          sx={{ width: "200px" }}
                        />
                      </Stack>
                      <ContainedButton
                        label={"Register Type ID"}
                        sx={{
                          width: "fit-content",
                          fontWeight: 600,
                          color: "#ffffff",
                        }}
                      />
                    </Stack>
                  </Stack>
                </Grid>
                <Grid size={{ xs: 12, md: 4, lg: 4 }} mt={"10px"}>
                  <CustomOutlinedSelect
                    label={"Computation Operand"}
                    options={[
                      { label: "Add", value: "" },
                      { label: "Multiply", value: "" },
                      { label: "Subtract", value: "" },
                      { label: "Less-than", value: "" },
                      { label: "Greater-than", value: "" },
                    ]}
                    placeholder={"Select any operand"}
                  />
                </Grid>
                {(registerTypeForOperand.value1 != "" ||
                  registerTypeForOperand.value2 != "") &&
                  (registerTypeForOperand.value3 != "" ||
                    registerTypeForOperand.value4 != "") && (
                    <Grid size={{ xs: 12, md: 4, lg: 4 }} ml={2} mt={"50px"}>
                      <Typography variant="body1">Result : </Typography>
                    </Grid>
                  )}
              </>
            )}

            <Grid size={{ xs: 12, md: 4, lg: 4 }} mt={"10px"}>
              <Stack direction={"column"} gap={"15px"}>
                <Typography variant="body1">Calculation Logic</Typography>
                <CustomInput placeholder={"Calculation.java"} />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Layout>
  );
};

export default RegisterRules;
